import {Group} from "../../../models/group";
import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {GroupService} from "../../../services/group/group.service";
import {combineLatest} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {CustomValidators} from "../../../calsses/CustomValidators";
import {MessagesService} from "../../../services/messages/messages.service";

@Component({
    selector: 'app-edit-group',
    templateUrl: './edit-group.component.html',
    styleUrls: ['./edit-group.component.scss']
})

export class EditGroupComponent implements OnInit {

    group: Group;
    groupId: string;
    projectId: string;
    databaseId: string;

    groupForm: FormGroup;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private formBuilder: FormBuilder,
        private groupService: GroupService,
        private messagesService: MessagesService
    ) {}

    ngOnInit() {
        combineLatest(
            this.route.parent.params,
            this.route.params
        ).subscribe(
            params => {
                this.projectId = params[0]['project_id'];
                this.groupId = params[1]['group_id'];
                this.databaseId = params[0]['database_id'];

                this.groupForm = this.formBuilder.group({
                    name: ['', [Validators.required]],
                    price: ['', [CustomValidators.priceValidator()]],
                });

                this.groupService.getSingleGroup(this.projectId, this.databaseId, this.groupId)
                    .subscribe(
                        () => this.group = this.groupService.group,
                        err => this.messagesService.errorToast(err),
                        () => this.groupForm.patchValue({...this.group.getObj(), database_id: this.databaseId})
                    )
            },
            err => this.messagesService.errorToast(err)
        );
    }

    onSubmit() {
        const payload = new Group(this.groupForm.getRawValue());

        this.groupService.patchGroup(this.projectId, this.databaseId, this.groupId, payload)
            .subscribe(
                () => {
                    this.messagesService.successModal('Group updated!', 'Done!');
                  this.router.navigate(['/projects/' + this.projectId + '/databases/' + this.databaseId])
                        .catch(err => this.messagesService.errorToast(err));
                },
                err => this.messagesService.errorToast(err)
            )
        ;
    }
}
